import type { ReactNode } from 'react';

export interface Brand {
  name: string;
  tagline: string;
  accent: string;
  logo: ReactNode;
}

// The MeOnSteroids mark: a lime "M" formed from an ascending soundwave on a dark tile.
const MeOnSteroidsLogo = (
  <svg width="44" height="44" viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <defs>
      <linearGradient id="mos-lime" x1="256" y1="720" x2="768" y2="304" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#a6e21f" />
        <stop offset="1" stopColor="#d4ff4d" />
      </linearGradient>
    </defs>
    <rect width="1024" height="1024" rx="220" fill="#12141b" />
    <g stroke="url(#mos-lime)" strokeWidth="70" strokeLinecap="round" fill="none">
      <path d="M270 720 L270 360 L512 600 L754 360 L754 720" />
    </g>
  </svg>
);

export const BRANDS: Record<string, Brand> = {
  meonsteroids: {
    name: 'MeOnSteroids',
    tagline: 'Sign in to continue to MeOnSteroids',
    accent: '#c8ff3d',
    logo: MeOnSteroidsLogo,
  },
};

export function getBrand(key?: string | null): Brand | null {
  if (!key) return null;
  return BRANDS[key.toLowerCase()] ?? null;
}
